import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-arrow-right.tsx
/**
* icon.24.arrow.right
*
* Keywords: chevron, navigation, forward, direction, pointer, next, movement, horizontal
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNNy41IDExLjVBLjUuNSAwIDAgMSA4IDExaDYuNzkzbC0zLjE0Ny0zLjE0NmEuNS41IDAgMCAxIC43MDgtLjcwOGw0IDRhLjUuNSAwIDAgMSAwIC43MDhsLTQgNGEuNS41IDAgMCAxLS43MDgtLjcwOEwxNC43OTMgMTJIOGEuNS41IDAgMCAxLS41LS41IiBjbGlwLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4=)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=1-2853
*/
const Icon24ArrowRight = memo(function Icon24ArrowRight(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			fillRule: "evenodd",
			d: "M7.5 11.5A.5.5 0 0 1 8 11h6.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L14.793 12H8a.5.5 0 0 1-.5-.5",
			clipRule: "evenodd"
		})
	});
});
//#endregion
export { Icon24ArrowRight };

//# sourceMappingURL=icon-24-arrow-right.js.map